module.exports = __webpack_public_path__ + "static/media/Self2.6283595a.jpg";